module.exports = __webpack_public_path__ + "img/black.07ec7e7a.png";